import { BRAZILIAN_STATES } from '~/utils';

export const isBrazilianState = (value: string | undefined): boolean => {
  return !!value && !!(value.toUpperCase() in BRAZILIAN_STATES);
};

export const isValidMaxLength = (
  value: string | undefined,
  maxLength: number,
): boolean => {
  return !value || value.length <= maxLength;
};
